export default __webpack_public_path__ + "static/media/apple-a.f63730b0.svg";